import React from 'react';
import Pricing from "./Pricing";
import {RaisedButton, Snackbar} from "material-ui";
import {validateEmail} from "../helpers";
import {trim} from "lodash";
import { connect } from 'react-redux';
import {createSubscriber} from "../actions/lead";
import {withRouter} from "react-router-dom";

class Technology extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: ''
        }
    }

    onHandleRequestClose = () => {
        this.setState({
            snackOpen: false,
        });
    }

    onSubmit = async (e) => {
        e.preventDefault();
        if (await this.validate()) {
            const body = {
                email: this.state.email,
                subscription_for: trim(`${window.location.pathname}`,'/') ? trim(`${window.location.pathname}`,'/') : 'home'
            };
            this.setState({disabled: true});
            const res = await this.props.createSubscriber(body);
            if (res) {
                this.setState({
                    snackOpen: true,
                    email: '',
                });
            } else {
                alert('Something Went Wrong.');
            }
        }
    }

    onInputChange = (e, key) => {
        this.setState({
            [key]: e.target.value
        });
    }

    validate = async () => {
        let validateFlag = true;
        if (!validateEmail(this.state.email)) {
            validateFlag = false;
            this.setState({
                emailError: alert(`Not a valid Email`)
            });
        } else {
            this.setState({
                emailError: ''
            });
        }
        return validateFlag;
    }

    render(){
        return(
            <div>
                <section className="hero-area">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6 order-lg-2">
                                <div className="hero-image">
                                    <img src="images/analytics.png"/>
                                </div>
                            </div>
                            <div className="col-lg-6 order-lg-1">
                                <div className="hero-content">
                                    <h1>Complete technology suite for any lending firm</h1>
                                    <p>Futuristic lending solution developed on advanced technology platform, innovating and disrupting retail lending market. Cloud deployment provides flexibility in scale while optimizing costs by supporting pay-per-use models. 
                                    </p>
                                    <div className="hero-form">
                                        <form onSubmit={e => this.onSubmit(e)}>
                                            <div className="form-group">
                                                <input
                                                    onError={this.state.emailError}
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter your email address"
                                                    value={this.state.email}
                                                    onChange={e => this.onInputChange(e, 'email')}
                                                />
                                                <RaisedButton
                                                    style={{
                                                        width: '150',
                                                        height: '60',
                                                        fontSize: '16'
                                                    }}
                                                    className = 'submit-btn'
                                                    type= "SUBMIT"
                                                    label = 'Subscribe'
                                                    labelColor = '#ffffff'
                                                    backgroundColor = '#925a94'
                                                />
                                                <Snackbar
                                                    open={this.state.snackOpen}
                                                    message='Thank you for Schedule Demo'
                                                    autoHideDuration={4000}
                                                    onRequestClose={this.onHandleRequestClose}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                <section className="feature-section">
                    <div className="shape">
                        <img src="image/landing-1-shape.svg" />
                    </div>
                    <div className="container">
                        <div className="section-title text-center align-items-center">
                            <h2>Our Products</h2>
                        </div>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-5 col-sm-6 col-10">
                                <div className="content-img">
                                    <img src="images/los_ascend_bizcap.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-5  offset-xl-1 col-lg-6 col-md-7 col-sm-6 ">
                                <div className="content-left-content">
                                    <h2>Loan Origination System (LOS)</h2>
                                    <p>Accelerated go-to-market and onboard customer within minutes across multiple platforms (web/mobile app)</p>
                                </div>
                                    <div className="content-link">
                                        <a className="btn btn-link right-icon" data-toggle="collapse" href="#multiCollapseExample1"
                                       role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Key Features<i className="icon icon-minimal-right"></i></a>
                                    </div>
                                <div className="row">
                                        <div className="collapse multi-collapse" id="multiCollapseExample1">
                                            <ul className="content-list accordian">
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Advanced CRM(Customer Relationship Management)
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Fully Automated KYC
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Automated documents reading to save operations cost
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Easy loan pipeline and status tracking for staff and channel partners
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Credit rule engine and integration with credit bureaus
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Configurable workflows and loan products
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Deviation and checklist creations and role based approvals
                                                </li>
                                            </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content-section-02">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                                <div className="content-img">
                                    <img src="images/lms_ascend_bizcap.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-5  col-sm-6 order-sm-1">
                                <div className="content-left-content">
                                    <h2>Loan Management System (LMS)</h2>
                                    <p>
                                        LMS is an advanced and comprehensive bank loan management system that aims to improve the quality, turnaround time and service for end-customers. It enables banks to improve the agility, transparency and efficiency of their lending solutions. As a loan management solution, it enables financial institutions to automate the processes for achieving cost savings and enhanced customer experience.
                                    </p>
                                    <div className="content-link">
                                        <a className="btn btn-link right-icon" data-toggle="collapse" href="#multiCollapseExample2"
                                           role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Key Features<i className="icon icon-minimal-right"></i></a>
                                    </div>
                                    <div className="row">
                                        <div className="collapse multi-collapse" id="multiCollapseExample2">
                                            <ul className="content-list accordian">
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Configurable MIS and Reports
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Analytics
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Easy accounting integration
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Flexiblility for loan restructuring, balance transfer and moratorium
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Flexible payment handling, maintain easy to read ledgers
                                                </li>
                                                <li>
                                                    <span><i className="icon icon-check-2"></i></span>Effective and timely customers communication and notifications
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="feature-section">
                    <div className="shape">
                        <img src="image/landing-1-shape.svg" />
                    </div>
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-5 col-lg-6 col-md-5 col-sm-6 col-10">
                                <div className="content-img">
                                    <img src="images/collection_ascend_bizcap.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-5  offset-xl-1 col-lg-6 col-md-7 col-sm-6 ">
                                <div className="content-left-content">
                                    <h2>Collection</h2>
                                    <p>
                                        Complete collection suite for end-to-end collection process starting from emi collection to legal process. Configurable collection process and strategy to reduce operations cost. Integrate with multiple collection agencies and receive payments in various formats (cash/online payment)
                                    </p>
                                    <div className="accordian_list">
                                        <div className="content-link">
                                            <a className="btn btn-link right-icon" data-toggle="collapse" href="#multiCollapseExample3"
                                               role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Key Features<i className="icon icon-minimal-right"></i></a>
                                        </div>
                                        <div className="row">
                                            <div className="collapse multi-collapse" id="multiCollapseExample3">
                                                <ul className="content-list accordian">
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Automatic collection strategy, loan assignments and route planning
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Rule based Payment Reminders and Notifications
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>NACH/eNACH registration and debit emi support
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Flexible workflows
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Configurable dashboard to check portfolio performance and check early indicators
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Payment links, electronic receipts
                                                    </li>
                                                    <li>
                                                        <span><i className="icon icon-check-2"></i></span>Maintain epossessed asset details, with support for valuation and disposal
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    {/*<ul className="content-list">*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Automatic collection strategy, loan assignments and route planning*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Rule based Payment Reminders and Notifications*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>NACH/eNACH registration and debit emi support*/}
                                    {/*    </li>*/}
                                    {/*     <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Flexible workflows*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Configurable dashboard to check portfolio performance and check early indicators*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Legal case handling*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Payment links, electronic receipts*/}
                                    {/*    </li>*/}
                                    {/*    <li>*/}
                                    {/*        <span><i className="icon icon-check-2"></i></span>Maintain epossessed asset details, with support for valuation and disposal */}
                                    {/*    </li>*/}
                                    {/*</ul>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content-section-02 pricing">
                    <div className="container">
                        <div className="row justify-content-center align-items-center">
                            <div className="col-xl-5 offset-xl-1 col-sm-6 col-10 order-sm-2">
                                <div className="content-img">
                                    <img src="images/staff_management.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-5  col-sm-6 order-sm-1">
                                <div className="content-left-content">
                                    <h2>Staff Productivity</h2>
                                    <p>
                                        Improve your staff productivity and reduce costs
                                    </p>
                                    <ul className="content-list">
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Attendance and HR Portal
                                        </li>
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Automatic task allocations and updates tracking
                                        </li>
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Internal chat 
                                        </li>
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Dashboard for team performance and TAT 
                                        </li>
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Geolocations and geotagging 
                                        </li>
                                        <li>
                                            <span><i className="icon icon-check-2"></i></span>Pendencies tracking
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/*<Pricing />*/}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    createSubscriber: body => dispatch(createSubscriber(body)),
});

export default withRouter(connect(null, mapDispatchToProps)(Technology));



// WEBPACK FOOTER //
// ./src/components/Technology.js